/**
 * Bank-First (W7) "connect the bank" intent, carried across the trial
 * paywall → /payment/checkout → iCount → /payment/success round trip so the
 * success page can resume to /openFinance/connect.
 *
 * Stored with a timestamp and honored only while fresh: a user who opened
 * the paywall from the bank CTA, closed it, and paid for something else an
 * hour later must not be redirected to the bank connection.
 */
const KEY = "bankFirstIntent";
export const BANK_FIRST_INTENT_TTL_MS = 30 * 60 * 1000;

export const setBankFirstIntent = (now: number = Date.now()) => {
  try {
    localStorage.setItem(KEY, String(now));
  } catch {}
};

export const clearBankFirstIntent = () => {
  try {
    localStorage.removeItem(KEY);
  } catch {}
};

export const isBankFirstIntentFresh = (
  raw: string | null | undefined,
  now: number = Date.now()
): boolean => {
  if (!raw) return false;
  const setAt = Number(raw);
  if (!Number.isFinite(setAt)) return false;
  return now - setAt >= 0 && now - setAt <= BANK_FIRST_INTENT_TTL_MS;
};

export const hasFreshBankFirstIntent = (now: number = Date.now()): boolean => {
  try {
    return isBankFirstIntentFresh(localStorage.getItem(KEY), now);
  } catch {
    return false;
  }
};
